import { Component } from '@angular/core';

/**
 * The flows admin inside the order parser, for tenants that use Gung only for the parser: the flow an order
 * is placed in carries its order params (season, order type, ...). Flow conditions are still set by Gung.
 */
@Component({
  selector: 'lib-pdf-ai-parser-flows',
  standalone: false,
  templateUrl: './pdf-ai-parser-flows.component.html',
  styleUrl: './pdf-ai-parser-flows.component.scss'
})
export class PdfAiParserFlowsComponent {}
